export default __webpack_public_path__ + "locales/pl/Settings.json?hash=d082b59d24fa721b0e7b28eefef547c3";